import gql from 'graphql-tag';

export const CREATE_PRODUCT = gql`
	mutation createProductMutation($input: CreateProductInput!) {
		createProduct(input: $input) {
			id
			name
			audioName
			minPick
			minPickType
			HCGCategory
			HFDCategory
			cost
			defaultPrice 
			weight
			imageUrl
			expiryDatePolicy

			energy
			protein
			fat
			saturated
			carbohydrate
			sugars
			sodium
			excludeFromStock
			excludeFromRecommended
			excludeFromTubWeightCalculation
			tags {
				id
				name
			}
		}
	}
`;
